import { useMemo } from 'react';

import { useBestPracticeComplianceStandardsQuery } from 'hooks/queries/security-insights';

import { useClustersOrFixture } from './useClustersOrFixture';
import { useActiveClusters } from '../../_hooks';

type UseGetBestPracticeComplianceStandardsProps = {
  clusterIds?: string[];
};

export const useGetBestPracticeComplianceStandards = ({
  clusterIds: scopedClusterIds,
}: UseGetBestPracticeComplianceStandardsProps = {}) => {
  const { clusters: _clusters, isLoading: isLoadingClusters } =
    useActiveClusters({ enabled: !scopedClusterIds });

  const { clusters } = useClustersOrFixture(_clusters);

  const clusterIds = useMemo(
    () => scopedClusterIds ?? clusters?.map((cluster) => cluster.id) ?? [],
    [scopedClusterIds, clusters]
  );

  const {
    isLoading: isLoadingComplianceStandards,
    complianceStandards = [],
    error,
    refetch,
  } = useBestPracticeComplianceStandardsQuery({
    clusterIds: clusterIds,
  });

  return {
    complianceStandards,
    isLoading:
      isLoadingComplianceStandards ||
      (scopedClusterIds ? false : isLoadingClusters),
    error,
    refetch,
  };
};
